export const ACCOUNTING_STATEMENT_BREIF =
  '/api/v1/accounting/statement/filter/brief/0/0';
